import { CustomError } from './CustomError';
import { ValidationError } from './ValidationError';
import type { ConflictError } from './ConflictError';
import { ErrorCodes } from '../literals';
import type { NotFoundError } from './NotFoundError';
import { ForbiddenError } from './ForbiddenError';

// TODO: maybe we need to use errorType instead of instanceof
export const isCustomError = (err: unknown): err is CustomError => err instanceof CustomError;

export const isValidationError = (err: unknown): err is ValidationError =>
  err instanceof ValidationError && err.status === ErrorCodes.validation;

export const isConflictError = (err: unknown): err is ConflictError =>
  isCustomError(err) && err.status === ErrorCodes.conflict;

export const isNotFoundError = (err: unknown): err is NotFoundError =>
  isCustomError(err) && err.status === ErrorCodes.notFound;

export const isForbiddenError = (err: unknown): err is ValidationError =>
  err instanceof ForbiddenError && err.status === ErrorCodes.forbidden;
